import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { useNavigationContext } from '../NavigationContext/index.js';
export function SubmenuHeader({ title, isSimpleNav }) {
    const { collapsed } = useNavigationContext();
    const classes = classNames(`twds-mb-1 twds-truncate twds-mr-4 ${isSimpleNav ? 'twds-ml-2' : 'twds-ml-3'}  twds-box-border twds-font-lato twds-text-blue-steel-600 dark:twds-text-gray-600`, isSimpleNav && !collapsed && 'twds-pl-14');
    return (React.createElement("div", { "data-testid": "submenuheader", className: classes },
        React.createElement("span", null, title)));
}
//# sourceMappingURL=SubmenuHeader.js.map